module.exports = ".sidebar-nav > ul > li.active > a{\n\tcolor: #ffffff !important;\n}"